import request from '@/utils/request'

// 查询商品编码列表
export function listCode(query) {
  return request({
    url: '/server/code/list',
    method: 'get',
    params: query
  })
}

// 查询商品编码生成条数列表
export function listDet(data) {
  return request({
    url: '/server/code/listDet',
    method: 'GET',
    params: data
  })
}


// 获取最多可生成的商品编码数量
export function getMaxNum(data) {
  return request({
    url: '/server/code/getMaxNum',
    method: 'get',
    params: data
  })
}

// 新增商品编码
export function addCode(data) {
  return request({
    url: '/server/code/add',
    method: 'POST',
    data: data
  })
}

// 修改商品编码状态
export function editFlag(data) {
  return request({
    url: '/server/code/editFlag',
    method: 'POST',
    data: data
  })
}

// 获取最多可生成的商品编码数量
export function listPlat(data) {
  return request({
    url: '/server/code/listPlat',
    method: 'get',
    params: data
  })
}

// 获取最多可生成的商品编码数量
export function importPlatCodeEAN(data) {
  return request({
    url: '/server/code/importPlatCode?productCodeType=EAN',
    method: 'post',
    data: data
  })
}
// 获取最多可生成的商品编码数量
export function importPlatCodeUPC(data) {
  return request({
    url: '/server/code/importPlatCode?productCodeType=UPC',
    method: 'post',
    data: data
  })
}
